import type { StreamDefinition } from '../../domain/model/Stream.types';
import { toApiSearchFilter, toSearchFilter } from './common.mapper';
import type * as api from './generated/api';
import type { CreateStreamDefinition } from './streamsApi';

export const toStreamDefinitions = (input: api.StreamList): StreamDefinition[] => input.items.map(toStreamDefinition);

export const toApiCreateStreamDefinition = (item: CreateStreamDefinition): api.Stream => ({
    id: item.id,
    filter: toApiSearchFilter(item.filter),
});

const toStreamDefinition = (input: api.Stream): StreamDefinition => ({
    id: input.id,
    filter: toSearchFilter(input.filter),
    // biome-ignore lint/style/noNonNullAssertion: We can be reasonably sure the value is present here
    startedAt: input.started_at!,
    endedAt: input.ended_at ? input.ended_at : undefined,
});
